/* eslint-disable import/prefer-default-export */

export const isValidNumber = number => (number !== undefined && number !== 0);

const formatSegmented = data => data.segmented.map((segmented) => {
    const {
        cost, goalCompletion, transactions, conversions, clicks, transactionsRevenue,
    } = segmented;
    return {
        ...segmented,
        cost_per_goal: isValidNumber(goalCompletion) ? cost / goalCompletion : 0,
        cost_per_transaction: isValidNumber(transactions) ? cost / transactions : 0,
        conv_rate: isValidNumber(clicks) ? conversions / clicks : 0,
        roi_ga: isValidNumber(transactionsRevenue) ? transactionsRevenue / cost : 0,
    };
});

export const addCalculatedMetrics = ({ data }) => ({
    ...data,
    total: data.total,
    segmented: formatSegmented(data),
});
